module.exports = __webpack_public_path__ + "static/assets/4d2505a9585bdd670e28cd76bc0af9d8.svg";